export default "__VITE_ASSET__Bdkil4te__"